
import { BehaviorSubject } from "rxjs";
import { ControlDataSource } from "../../data-source-utils";
import { SubjectMapped, _IDataSourceControlBase } from "../../types";

export class _SSDataSourceBase implements Required<SubjectMapped<_IDataSourceControlBase>> {

  readonly useRemotesSubject = new BehaviorSubject<boolean>(false);
  readonly valueExprSubject = new BehaviorSubject<string>('value');
  readonly displayExprSubject = new BehaviorSubject<string | ((data: any) => string)>('display');
  readonly valueIsDisplaySubject = new BehaviorSubject<boolean>(false);
  readonly dataSourceSubject = new BehaviorSubject<ControlDataSource<any>>(undefined);
  readonly pageSizeSubject = new BehaviorSubject<number>(0);
  readonly templateSubject = new BehaviorSubject<_IDataSourceControlBase['template']>(undefined);
  readonly dataSubject = new BehaviorSubject<any[]>(undefined)

  constructor() { }


}
